module.exports = __webpack_public_path__ + "img/gold_vip.a9feb833.png";